import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getCredentialTypeData from './GetCredentialTypeData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  dataAsOptionsWithNames: []
};

const CredentialTypeData = {
  getCredentialTypeData,
  INITIAL_STATE
};

export default CredentialTypeData;